import React from "react";
import { Intent, Button, Callout } from "@blueprintjs/core";
import classnames from "classnames";

import FormSection from "../../../../atoms/FormSection/FormSection";
import styles from "../ShippingSettings.module.scss";
import FormInfo from "../../../../atoms/FormInfo/FormInfo";
import FormHeading from "../../../../atoms/FormHeading/FormHeading";
import { getShippingRuleRange } from "../ShippingProfileDetail/helpers";
import ShippingRateDialog from "./ShippingRateDialog";

export default function ShippingRateList({
  shippingRules,
  onAddShippingRule,
  onEditShippingRule,
  ...shippingRuleProps
}) {
  return (
    <>
      <ShippingRateDialog {...shippingRuleProps} />
      <FormSection className={classnames(styles.formSection, styles.noBorder)}>
        <FormHeading
          rightElement={
            <Button
              text="Create Shipping Rate"
              minimal
              intent={Intent.PRIMARY}
              onClick={onAddShippingRule}
            />
          }
        >
          Shipping Rates
        </FormHeading>
        {!shippingRules.length && (
          <Callout
            intent={Intent.NONE}
            icon="info-sign"
            className={styles.calloutSpace}
          >
            No rates - Create rates for places you want to ship to.
          </Callout>
        )}
        <FormSection
          className={classnames(styles.shippingZone, styles.shippingRates)}
        >
          {shippingRules.map((rule) => (
            <FormSection
              className={styles.formSection}
              onClick={() => onEditShippingRule(rule.id)}
            >
              <FormInfo className={styles.title}>{rule.condition}</FormInfo>
              <div className={styles.flexRow}>
                <FormInfo className={styles.value}>
                  {getShippingRuleRange(rule.min, rule.max, rule.condition)}
                </FormInfo>
                <FormInfo className={styles.value}>
                  {rule.rate ? `$${rule.rate}` : `Free`}
                </FormInfo>
              </div>
            </FormSection>
          ))}
        </FormSection>
      </FormSection>
    </>
  );
}
